'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));

/**
 * 
 * @param {*} props 
 * @returns 
 */

var Code = function Code(props) {
  var debug = props.general.debug;

  if (!debug || debug === 'false') {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: '2rem',
      background: '#222',
      color: '#eee',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React__default.createElement("pre", {
    style: {
      fontSize: 13,
      lineHeight: 1.5
    }
  }, JSON.stringify(_rollupPluginBabelHelpers.objectSpread2({}, props), null, '    ')));
};

Code.propTypes = {
  general: PropTypes.object
};

module.exports = Code;
